<template>
    <div class="panel-about">
        <div class="index-container">
            <div class="index-title-group">
                <div class="index-title"><div>关于我们</div></div>
                <div class="index-title-sub">专业的人工智能与机器视觉解决方案提供商</div>
            </div>
            <div class="about-body">
                <div class="about-content">
                    <div class="about-title">大连沣同科技有限公司</div>
                    <p>大连沣同科技有限公司，在一家专注于制造企业数字化软件研发和应用推广的高科技企业，集研发、销售、实施和服务与一体，是国内专业的制造企业数字化解决方案提供商</p>
                    <p>公司致力于用信息技术提升客户价值，在信息技术领域成就客户、实现客户梦想。形成了以企业数字化、人工智能与数字图像为核心的服务体系。为客户提供数字工厂的咨询、规划、设计、实施、运维、优化的一体化解决方案。</p>
                </div>
                <img src="../../resource/img/index/about.jpg" style="width: 35vw;">
            </div>
        </div>
    </div>
</template>

<script>

export default {
name: "about"
}
</script>

<style scoped>
.panel-about {
    padding: 65px 0 45px;
    background-color: #FFFFFF;
}

.about-body {
    margin-top: 40px;
    display: flex;
}

.about-content {
    flex: 1;
    padding-right: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.about-title {
    font-size: 22px;
    color: #0171cb;
    font-weight: bold;
}

.about-content p {
    font-size: 18px;
    color: #484846;
    line-height: 180%;
    margin: 20px 0;
}
</style>
